import { render, staticRenderFns } from "./project-info.vue?vue&type=template&id=591e83b7&"
import script from "./project-info.vue?vue&type=script&lang=js&"
export * from "./project-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports